<template>
    <div class="myProject-box">
        <div
            v-if="defaultState === 'more' || defaultState === 'one'"
            class="projectMain"
        >
            <template v-for="(projectItem, index) in projectList">
                <div
                    :key="projectItem.uuid + 'list'"
                    class="projectBread"
                    @click="expand(projectItem)"
                >
                    <img
                        v-if="defaultState === 'more'"
                        src="@/assets/images/contacts/arrow_contact.png"
                        alt=""
                        class="arrow"
                        :class="{ rotate: projectItem.expand }"
                    >
                    <p class="breadDetail">
                        <span :key="projectItem.uuid">{{
                            projectItem.spaceName
                        }}</span>
                    </p>
                </div>
                <div
                    v-if="projectItem.data"
                    v-show="projectItem.expand"
                    :key="index"
                    class="projectDetail"
                    :class="{ hasArrow: defaultState === 'more' }"
                    :for="projectItem.uuid"
                >
                    <label
                        v-show="projectItem.data.length > 0"
                        class="allCheck"
                    >
                        <label
                            class="checkIcon"
                        ><input
                            :id="projectItem.uuid"
                            v-model="selectedProjects"
                            type="checkbox"
                            :value="projectItem.uuid"
                            @change="
                                changeAllCheck($event, projectItem)
                            "
                        ><i /></label><span>全选</span>
                    </label>
                    <ul
                        v-if="projectItem.data && projectItem.data.length > 0"
                        class="memberList"
                    >
                        <label
                            v-for="memberItem in projectItem.data"
                            :key="memberItem.lxAccount"
                            class="member"
                            :for="memberItem.id"
                            @change="changeMemberCheck($event, memberItem)"
                        >
                            <label
                                class="checkIcon"
                            ><input
                                :id="memberItem.id"
                                v-model="selectedIdList"
                                type="checkbox"
                                :value="memberItem.id"
                                :disabled="isDisabled(memberItem)"
                            ><i /></label>
                            <Avatar class="avatar" :user="memberItem" />
                            <div class="detail">
                                <p class="name">
                                    <span class="name-flex">{{
                                        memberItem.name
                                    }}</span>
                                    <span
                                        class="account"
                                    >({{ memberItem.lxAccount }})</span>
                                    <span
                                        v-if="
                                            memberItem.userType &&
                                                memberItem.userType !== ''
                                        "
                                        class="tag"
                                    >
                                        <span>{{
                                            memberItem.userType === 1
                                                ? '内部'
                                                : '供方'
                                        }}</span>
                                    </span>
                                </p>
                                <p class="position">
                                    {{ memberItem.job }}
                                </p>
                            </div>
                        </label>
                    </ul>
                    <div
                        v-show="
                            projectItem.data.length === 0 &&
                                defaultState === 'more'
                        "
                        class="org-default-bg"
                    >
                        <span>暂无数据</span>
                    </div>
                    <div
                        v-show="
                            projectItem.data.length === 0 &&
                                defaultState === 'one'
                        "
                        class="org-default-bg-img"
                    >
                        <img
                            src="../../../assets/images/contacts/org-window-empty-bg.png"
                            class="bgImg"
                            alt=""
                        >
                        <span>暂无数据</span>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="defaultState === 'loading'" class="org-status">
            <img
                src="https://s1.longfor.com/image/40348b3e1ff6aa6833902accafcc0c4f.gif"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                加载中
            </p>
        </div>
        <div v-if="defaultState === 'none'" class="org-status">
            <img
                src="../../../assets/images/contacts/org-window-empty-bg.png"
                class="status-img"
                alt=""
            >
            <p class="status-text">
                暂无所属项目
            </p>
        </div>
        <div v-if="defaultState === 'dataLoadingFailed'" class="org-status">
            <img
                src="@/assets/images/contacts/data_loading_failed.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                数据加载失败，请重试
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
        <div v-if="defaultState === 'serviceAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/service_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                服务异常，请联系IT报事
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
        <div v-if="defaultState === 'networkAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/network_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                当前网络不可用，请检查网络设置
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getUserProjectInfoPage,
    getProjectDetail,
    pageRequest
} from '@/apis/contactsWindow/contactsWindow'
import Avatar from '@/components/Avatar'
import contactsConfig from '@/utils/contacts/config'
export default {
    name: 'MyProject',
    components: {
        Avatar
    },
    props: {
        selected: {
            type: [Array],
            required: false,
            default: () => []
        },
        countLimit: {
            type: [Number],
            required: true
        },
        isStaff: {
            type: Boolean,
            required: true,
            default: false
        },
        loginRights: {
            type: Object,
            required: true
        },
        defaultSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        canNotSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        projectId: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            projectList: [], // 我的项目基本信息
            defaultState: '', // loading：未获取到，none：projectList为空，more：projectList>1，one：projectList===1
            selectedProjects: [], // 选择的项目
            pageNum: 1,
            pageSize: 100
        }
    },
    computed: {
        selectedIdList: {
            get() {
                return this.selected.map(item => item.id)
            },
            set() {}
        },
        defaultIdList() {
            return (this.defaultSelected || []).map(item => item.id)
        },
        canNotSelectedIds() {
            return this.canNotSelected || []
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade
                ? -1
                : +this.loginRights.authorityGrade
        }
    },
    watch: {
        selectedIdList(newVal) {
            if (this.projectList.length > 0) {
                for (let i = 0; i < this.projectList.length; i++) {
                    if (
                        this.projectList[i].data &&
                        this.projectList[i].data.length > 0
                    ) {
                        let flag = false
                        for (
                            let j = 0;
                            j < this.projectList[i].data.length;
                            j++
                        ) {
                            const member = this.projectList[i].data[j]
                            const memberId = member.uId
                            if (
                                newVal.indexOf(memberId) === -1 &&
                                !this.isDisabled(member)
                            ) {
                                flag = true // 如果该项目的其中一人不再已选列表，那么将flag=true
                                break // 如果有一个人不再已选列表，那么肯定不会全选了，break了提升性能
                            }
                        }
                        if (flag) {
                            this.$nextTick(() => {
                                this.selectedProjects = this.selectedProjects.filter(
                                    item => item !== this.projectList[i].uuid
                                )
                            })
                        } else {
                            // 已选中添加当前组织节点，继续递归
                            this.$nextTick(() => {
                                this.selectedProjects.push(
                                    this.projectList[i].uuid
                                )
                            })
                        }
                    }
                }
            }
        }
    },
    mounted() {
        setTimeout(() => {
            if (!this.defaultState) {
                this.defaultState = 'loading'
            }
        }, contactsConfig.loadingTimeout)
        this.projectList = []
        this.getProjectInfo()
    },
    methods: {
        reload() {
            this.defaultState = 'loading'
            this.getProjectInfo()
        },
        // 获取用户所有团队
        getProjectInfo() {
            const context = this
            getUserProjectInfoPage({
                pageNum: context.pageNum,
                pageSize: context.pageSize
            })
                .then(projectInfo => {
                    if (projectInfo.code === '0') {
                        if (
                            projectInfo.data &&
                            projectInfo.data.records &&
                            projectInfo.data.records.length > 0
                        ) {
                            projectInfo.data.records.forEach(item => {
                                item.expand = false
                            })
                        }
                        context.projectList = context.projectList.concat(
                            projectInfo.data.records
                        )
                        if (
                            projectInfo.data.records.length ===
                                context.pageSize &&
                            projectInfo.data.currentPage !==
                                projectInfo.data.pages
                        ) {
                            context.pageNum++
                            context.getProjectInfo()
                        } else {
                            this.handle()
                        }
                    } else {
                        this.defaultState = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    if (err.message === 'Network Error') {
                        context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        handle() {
            const context = this
            if (context.projectList.length === 0) {
                this.defaultState = 'none' // 无部门显示缺省图
            } else if (context.projectList.length > 1) {
                this.defaultState = 'more' // 多部门面包屑左边有箭头，自动展开第一组
                if (context.projectId) {
                    let showProject
                    for (let i = 0; i < context.projectList.length; i++) {
                        if (
                            context.projectList[i].uuid &&
                            context.projectList[i].uuid === context.projectId
                        ) {
                            showProject = context.projectList[i]
                            context.projectList.splice(i, 1)
                            break
                        }
                    }
                    if (showProject) {
                        context.projectList.unshift(showProject)
                    }
                }
                context.expand(context.projectList[0])
            } else {
                this.defaultState = 'one' // 单部门无箭头、且自动展开
                context.expand(context.projectList[0])
            }
        },
        // '首次'点击小三角触发，获取组织下的人员&组织信息
        expand(projectItem) {
            const context = this
            if (
                context.projectList.length === 1 &&
                projectItem.expand &&
                projectItem.data
            ) {
                // 单个项目的话，不用点击收起
                return
            }
            projectItem.expand = !projectItem.expand
            // 如果data里有数据，说明之前展开过，获取过数据，只需进行简单的展开/收起操作即可
            if (projectItem.expand && !projectItem.data) {
                const pageCount =
                    projectItem.memberCount === null
                        ? 1
                        : Math.ceil(+projectItem.memberCount / 500)
                const pageNum = 0
                const pageSize = 500
                const params = {
                    spaceId: projectItem.uuid
                }
                pageRequest(
                    pageNum,
                    pageSize,
                    pageCount,
                    getProjectDetail,
                    params
                )
                    .then(res => {
                        let allProjectData = []
                        let flag = false
                        for (let i = 0; i < res.length; i++) {
                            if (
                                res[i].code === '0' &&
                                res[i].data &&
                                res[i].data.records
                            ) {
                                allProjectData = allProjectData.concat(
                                    res[i].data.records
                                )
                            } else {
                                flag = true
                            }
                        }
                        if (flag) {
                            this.defaultState = 'dataLoadingFailed'
                            return
                        }
                        const members = context.formatUserData(allProjectData)
                        context.$set(projectItem, 'data', members)
                        context.renewAllCheck(projectItem)
                    })
                    .catch(err => {
                        console.warn(err)
                        if (err.message === 'Network Error') {
                            context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                        } else {
                            context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                        }
                    })
            }
        },
        // 格式化从后端获取的数据
        formatUserData(list) {
            const tempList = []
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                if (list[i].uid) {
                    // list[i].uid这个判断是为了兼容获取群详情里的staffs时format数据
                    obj = {
                        uId: list[i].uid || '',
                        id: list[i].uid || '',
                        headId: list[i].headId || '',
                        portraitUrl: list[i].portraitUrl || '',
                        name: list[i].memberName || '',
                        lxAccount: list[i].memberAccount || '',
                        userType: +list[i].memberTypeCode || '',
                        isExec: +list[i].isExec || 0,
                        job: list[i].job || '',
                        status: 1, // 后端已过滤，默认给1，在职
                        ex3: list[i].nickName
                    }
                    tempList.push(obj)
                }
            }
            return tempList
        },
        // 第一次展开团队时更新团队全选状态
        renewAllCheck(projectItem) {
            const context = this
            if (
                this.selectedIdList &&
                this.selectedIdList.length > 0 &&
                this.selectedIdList &&
                this.selectedIdList.length > 0
            ) {
                const expandProjectMembers = [] // 存一下展开团队的成员id集合（排除掉不可选的成员）
                for (let i = 0; i < projectItem.data.length; i++) {
                    if (!this.isDisabled(projectItem.data[i])) {
                        expandProjectMembers.push(projectItem.data[i].id)
                    }
                }
                const intersections = context.selectedIdList.filter(val => {
                    // 取团队成员与右侧已选列表成员的交集 => id集合
                    return expandProjectMembers.indexOf(val) > -1
                })
                if (intersections.length === expandProjectMembers.length) {
                    this.$nextTick(() => {
                        this.selectedProjects.push(projectItem.uuid)
                    })
                } else {
                    this.$nextTick(() => {
                        this.selectedProjects = this.selectedProjects.filter(
                            item => item !== projectItem.uuid
                        )
                    })
                }
            }
        },
        changeMemberCheck(event, item) {
            const checked = event.target.checked
            const context = this
            if (checked) {
                if (context.countLimit) {
                    const count = context.selected.length + 1
                    if (count > context.countLimit) {
                        context.$nextTick(() => {
                            // 人数超了不需要选中
                            event.target.checked = false
                        })
                        context.$emit('maxCountLimit')
                        return
                    }
                }
                // 先添加到 selected 列表中
                context.$emit('added', [item])
            } else {
                // 先 remove selected
                context.$emit('removed', [item])
            }
        },
        changeAllCheck(event, item) {
            const context = this
            const checked = event.target.checked
            if (checked) {
                context.addProject(item)
            } else {
                context.removeProject(item)
            }
        },
        // 选择一个项目
        addProject(item) {
            const context = this
            // 先从节点中删除掉当前已选节点，如果之后删除，页面会闪动选择。
            context.$nextTick(() => {
                context.selectedProjects = context.selectedProjects.filter(
                    uuid => uuid !== item.uuid
                )
            })
            const staffIds = context.selected.map(staff => staff.id)
            // 取全选的总人数-已选中的人中在该全选列表里的人，即去重后的新增人数
            const count = item.data.filter(
                staff => staffIds.indexOf(staff.uId) < 0
            ).length
            if (context.countLimit) {
                const selectedCount = count + context.selected.length
                if (selectedCount > context.countLimit) {
                    context.$emit('maxCountLimit')
                    return
                }
            }
            const members = item.data
            addMembers(members, context)
        },
        // 删除一个组织节点
        removeProject(item) {
            const context = this
            const members = item.data
            // 从已选列表中 remove staff
            if (members.length > 0) {
                context.$emit('removed', members)
            }
        },
        /* 成员的禁用状态，是否可选择、取消。 1.默认选中成员 */
        isDisabled(item) {
            return (
                this.isDefault(item) ||
                this.executiveLimit(item) ||
                this.isCannotSelected(item)
            )
        },
        isDefault(item) {
            return this.defaultIdList.indexOf(item.id) >= 0
        },
        executiveLimit(item) {
            if (this.isStaff && this.userLevel >= 1) {
                return false
            }
            const isExec = item && !!+item.isExec
            return isExec
        },
        isCannotSelected(item) {
            return this.canNotSelectedIds.indexOf(item.id) >= 0
        }
    }
}
/**
 * 添加人员
 * 排除已选中/不可被选中/离职
 * @param {Array<staff>} members
 * @param {Object} context
 */

function addMembers(members, context) {
    members = members.filter(item => !context.isDisabled(item))
    // 先给 members 去重
    members = uniq(members)
    members = without(members, context.selected)
    if (members.length > 0) {
        context.$emit('added', members)
    }
}

function uniq(array) {
    const map = {}
    return array.filter(item => {
        const id = item.id
        if (map[id]) {
            return false
        }
        map[id] = id
        return true
    })
}

function without(members, others) {
    const otherIds = others.map(item => item.id)
    return members.filter(item => otherIds.indexOf(item.id) < 0)
}
</script>

<style lang="scss" scoped>
.myProject-box {
    height: 100%;
    overflow-y: auto;
    .org-status {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 94px;
        box-sizing: border-box;
        .status-img {
            width: 90px;
            height: 90px;
        }
        .status-text {
            margin-top: 12px;
            font-size: 14px;
            line-height: 22px;
            color: #464646;
        }
        .status-reload {
            width: 180px;
            height: 36px;
            margin-top: 18px;
            .reload {
                width: 100%;
                height: 36px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 36px;
                border: 0;
                background: #007af5;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                    background-color: #006edd;
                }
            }
        }
    }
    .projectMain {
        .projectBread {
            margin-top: 12px;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            cursor: pointer;
            &:first-child {
                margin-top: 0;
            }
            .arrow {
                cursor: pointer;
                //margin-right: 3px;
                width: 24px;
                height: 24px;
                display: block;
                flex-shrink: 0;
                &.rotate {
                    transform: rotate(90deg);
                    // color: #5587F0;
                }
            }
            .breadDetail {
                span {
                    font-size: 14px;
                    line-height: 24px;
                    color: #6f6f6f;
                }
            }
        }
        .projectDetail {
            .checkIcon {
                cursor: pointer;
                display: flex;
                align-items: center;
                input {
                    display: none;
                    & + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-default.png');
                        background-size: 100% 100%;
                        &:hover {
                            background: url('../../../assets/images/contacts/org-window-choose-hover.png');
                            background-size: 100% 100%;
                        }
                    }
                    &:checked + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-ok.png');
                        background-size: 100% 100%;
                    }
                    &:checked[disabled] + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-no.png');
                        background-size: 100% 100%;
                    }
                    &[disabled] + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-disableno.png');
                        background-size: 100% 100%;
                    }
                }
            }
            .allCheck {
                height: 36px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                margin: 0 6px;
                padding: 0 6px;
                cursor: pointer;
                border-radius: 4px;
                &:hover {
                    background-color: #f5f5f5;
                }
                span {
                    font-size: 14px;
                    line-height: 24px;
                    color: #323232;
                    margin-left: 12px;
                }
            }
            .memberList {
                .member {
                    display: flex;
                    align-items: center;
                    height: 54px;
                    margin: 0 6px;
                    padding: 0 6px;
                    cursor: pointer;
                    border-radius: 4px;
                    &:hover {
                        background-color: #f5f5f5;
                    }
                    .avatar {
                        width: 36px;
                        height: 36px;
                        margin: 0 12px;
                    }
                    .detail {
                        flex: 1;
                        overflow: hidden;
                        .name {
                            font-size: 14px;
                            line-height: 22px;
                            color: #323232;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                            .name-flex {
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                max-width: 115px;
                                padding-right: 6px;
                            }
                            .account {
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                max-width: 115px;
                            }
                            .tag {
                                flex-shrink: 0;
                                width: 32px;
                                height: 18px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                background: rgba(0, 122, 245, 0.06);
                                font-size: 10px;
                                color: #007af5;
                                margin-left: 6px;
                                border-radius: 2px;
                                span {
                                    transform: scale(0.83);
                                }
                            }
                        }
                        .position {
                            font-size: 12px;
                            line-height: 18px;
                            color: #999999;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                }
            }
            .org-default-bg {
                height: 68px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #999;
                font-size: 12px;
            }
            .org-default-bg-img {
                height: 318px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #999;
                font-size: 12px;
                flex-direction: column;
                .bgImg {
                    width: 90px;
                    height: 90px;
                }
                span {
                    font-size: 14px;
                    line-height: 22px;
                    color: #464646;
                    margin: 12px 0;
                }
            }
            &.hasArrow {
                .allCheck,
                .member {
                    padding-left: 30px;
                }
            }
        }
    }
}
</style>
